function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M19.077 25.05h.987s.298-.03.45-.187c.141-.145.136-.415.136-.415s-.019-1.265.596-1.451c.606-.184 1.384 1.222 2.209 1.763.623.41 1.098.32 1.098.32l2.205-.03s1.153-.067.606-.934c-.045-.07-.319-.64-1.64-1.812-1.383-1.226-1.197-1.028.469-3.15 1.014-1.29 1.42-2.08 1.293-2.417-.121-.322-.867-.237-.867-.237l-2.483.015s-.185-.024-.321.054a.669.669 0 0 0-.219.254s-.393 1-.917 1.85c-1.106 1.794-1.548 1.888-1.729 1.777-.42-.26-.315-1.042-.315-1.599 0-1.738.276-2.463-.537-2.65-.27-.063-.47-.104-1.16-.11-.885-.01-1.635.002-2.06.2-.283.133-.5.427-.368.444.164.021.536.096.733.352.254.33.246 1.073.246 1.073s.146 2.046-.342 2.301c-.335.174-.794-.182-1.78-1.81-.505-.833-.886-1.754-.886-1.754s-.073-.172-.205-.265a1.061 1.061 0 0 0-.381-.147l-2.36.015s-.354.01-.484.157c-.116.13-.01.402-.01.402s1.848 4.128 3.94 6.209c1.918 1.908 4.096 1.782 4.096 1.782"
});

var SvgVk = function SvgVk(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vk.d1926890.svg";
export { ForwardRef as ReactComponent };